import { render, staticRenderFns } from "./search_box.vue?vue&type=template&id=39cb3b40&scoped=true&"
import script from "./search_box.vue?vue&type=script&lang=js&"
export * from "./search_box.vue?vue&type=script&lang=js&"
import style0 from "./search_box.vue?vue&type=style&index=0&id=39cb3b40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb3b40",
  null
  
)

export default component.exports